











































































































import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import { SETTING, STATUS, STATUS_ARRAY_INPUT } from "@/model/releaseSetting";
import moment from "moment";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";

@Component({
  name: "qReleaseSetting",
  components: {
    QErrors,
    QCalendar,
  },
})
export default class QReleaseSetting extends Vue {
  @Prop({
    required: true,
  })
  public status: string;

  @Prop({
    default: () => {
      return {
        openStatus: "status",
        releaseSetting: "release_setting",
        postDate: "post_date",
      };
    },
  })
  public name;

  @Prop({
    required: true,
    default: null,
  })
  public releaseSetting;

  @Prop({
    required: true,
    default: null,
  })
  public postDate;

  @Prop({
    default() {
      return {
        dateFormat: "Y-m-d",
        enableTime: false,
        allowInput: false,
      };
    },
  })
  public dateConfig: any;

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public errors;

  public statusList = STATUS_ARRAY_INPUT as any;

  public releaseStatus = STATUS.RELEASE;
  public releaseNowText = "今すぐ公開";

  public readonly RELEASE_NOW = SETTING.NOW;
  public readonly RELEASE_DATE = SETTING.DATE;

  public localStatus: any = STATUS.EDIT;
  public localPostDate = null;
  public localPostHours = null;
  public localPostMinute = null;
  public localReleaseSetting = "now";

  @Watch("status", { deep: true })
  public changeStatus(): void {
    this.localStatus = this.status;
  }

  @Watch("releaseSetting", { deep: true })
  public changeReleaseSetting(): void {
    this.localReleaseSetting = this.releaseSetting;
  }

  @Watch("postDate", { deep: true })
  public changePostDate(): void {
    if (this.postDate) {
      const postDate = new Date(this.postDate);
      this.localPostDate = moment(postDate).format("YYYY-MM-DD");
      this.localPostHours = postDate.getHours();
      this.localPostMinute = postDate.getMinutes();
    } else {
      this.localPostDate = null;
      this.localPostHours = null;
      this.localPostMinute = null;
    }
  }

  public changeLocalStatus(): void {
    this.$emit("updateStatus", this.localStatus);
    this.$emit("update:status", this.localStatus);
    if (this.localStatus !== this.releaseStatus) {
      this.localReleaseSetting = null;
    } else {
      this.localReleaseSetting = SETTING.NOW;
    }
    this.changeLocalReleaseSetting();
  }

  public changeLocalReleaseSetting(): void {
    this.$emit("updateReleaseSetting", this.localReleaseSetting);
    this.$emit("update:releaseSetting", this.localReleaseSetting);
    if (this.localReleaseSetting !== SETTING.DATE) {
      this.localPostDate = null;
    }
    this.changeLocalPostDate();
  }

  public changeLocalPostDate(): void {
    let postTime = null;
    if (this.localPostDate) {
      this.localPostHours = Math.min(Math.max(0, this.localPostHours), 23);
      this.localPostMinute = Math.min(Math.max(0, this.localPostMinute), 59);
      const hours = this.localPostHours.toString().padStart(2, "0");
      const minutes = this.localPostMinute.toString().padStart(2, "0");
      postTime = moment(`${this.localPostDate} ${hours}:${minutes}`).format(
        "YYYY-MM-DD HH:mm",
      );
    }

    this.$emit("updatePostDate", postTime);
    this.$emit("update:postDate", postTime);
  }

  public clearError(item) {
    this.$emit("clearError", item);
    this.$emit("update:errors", { ...this.errors, ...{ [this.name]: [] } });
  }
}
